module.exports = __webpack_public_path__ + "img/Group 27923@2x.90fbb204.png";